import axios from 'axios'

const state = {

};

const getters = {

};

const actions = {

    getFormationsConstants: async () => {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_INTRANET_API_URL + "form/formations", {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => reject(error));
        });
    },

}

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
};